import { render, staticRenderFns } from "./Pmd.vue?vue&type=template&id=ed3846d4&"
import script from "./Pmd.vue?vue&type=script&lang=ts&"
export * from "./Pmd.vue?vue&type=script&lang=ts&"
import style0 from "./Pmd.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports